import { ReduxHelper } from "helpers";
import { IImportBay4sRequest } from "model";

export const prefix = "REPORT";

export const importBay4s = ReduxHelper.generateActions<
  IImportBay4sRequest,
  any
>(prefix, "IMPORT_BAY4S_DATA");
export const clearAction = ReduxHelper.generateLocalAction(
  prefix,
  "CLEAR_ACTION"
);
